const ImagesCarouselConfig = [
    { span: 6, height: "30px", classes: "marginTop-32" },
    {
        classes: "marginTop-16",
        columns: [
            { span: 2, height: "150px" },
            { span: 2, height: "150px" },
            { span: 2, height: "150px" },
            { span: 2, height: "150px" },
            { span: 2, height: "150px" },
        ],
    },
]

export default ImagesCarouselConfig
